import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { ButtonDesktop as Button } from '@alfa-bank/site-button-v2/desktop';
import { Img } from '@alfa-bank/site-img';
import { CheckmarkOffCircleMIcon as CircleIcon } from '@alfalab/icons-glyph/CheckmarkOffCircleMIcon';

import { PlayIcon } from './components/play-icon';
import { YoutubeIcon } from './components/youtube-icon';
import { VideoPlayer as Component } from './video-player';
import type { IDeps, TVideoPlayer } from './models';
import styles from './styles/styles.css';

export const VideoPlayerDesktop = createWidget<IDeps, TVideoPlayer>({
    styles,
    Button,
    PlayIcon,
    CircleIcon,
    YoutubeIcon,
    Img,
})(Component);
